export const initialState: any = {
  ImageName: "",
  PricingValue: "",
  File: "",
  Comment: "",
  Height: 500,
  Width:500
}